export default "__VITE_ASSET__DZIbIUJZ__"